import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
}
const PURCHASES: Purchase[] = [{
  name: 'Martín G.',
  location: 'Buenos Aires'
}, {
  name: 'Lucía F.',
  location: 'Córdoba'
}, {
  name: 'Sebastián R.',
  location: 'Rosario'
}, {
  name: 'Camila P.',
  location: 'Mendoza'
}, {
  name: 'Nicolás A.',
  location: 'La Plata'
}, {
  name: 'Valentina S.',
  location: 'Mar del Plata'
}, {
  name: 'Joaquín M.',
  location: 'San Miguel de Tucumán'
}, {
  name: 'Sofía T.',
  location: 'Salta'
}, {
  name: 'Mateo L.',
  location: 'Santa Fe'
}, {
  name: 'Florencia D.',
  location: 'Neuquén'
}, {
  name: 'Tomás V.',
  location: 'San Juan'
}, {
  name: 'Julieta C.',
  location: 'Bahía Blanca'
}, {
  name: 'Agustín B.',
  location: 'Resistencia'
}, {
  name: 'Micaela N.',
  location: 'Posadas'
}, {
  name: 'Federico H.',
  location: 'Paraná'
}, {
  name: 'Carla O.',
  location: 'San Salvador de Jujuy'
}];
const TIME_AGO = ['hace 2 minutos', 'hace 4 minutos', 'hace 7 minutos', 'hace 1 minuto', 'hace 9 minutos', 'hace 3 minutos'];
const PRODUCTS = [{
  label: 'El Costo de No Hacer Nada',
  emoji: '💰'
}, {
  label: 'El Costo de No Hacer Nada PRO',
  emoji: '🚀'
}];
// Random integer between min and max (inclusive)
const randInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export function PurchasePopup() {
  const [current, setCurrent] = useState<{
    purchase: Purchase;
    ago: string;
    product: (typeof PRODUCTS)[number];
  } | null>(null);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    let cycleTimeout: ReturnType<typeof setTimeout>;
    const showNext = () => {
      const purchase = PURCHASES[index % PURCHASES.length];
      const ago = TIME_AGO[randInt(0, TIME_AGO.length - 1)];
      // Alternate between Esencial and PRO on each popup
      const product = PRODUCTS[index % PRODUCTS.length];
      setCurrent({
        purchase,
        ago,
        product
      });
      setIndex(prev => prev + 1);
      // Keep it visible for ~5 seconds
      hideTimeout = setTimeout(() => {
        setCurrent(null);
        // Schedule the next popup 40–60 seconds after this one hides
        cycleTimeout = setTimeout(showNext, randInt(40, 60) * 1000);
      }, 5000);
    };
    // First popup appears after an initial 12 second delay
    showTimeout = setTimeout(showNext, 12000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      clearTimeout(cycleTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);
  return <AnimatePresence data-id="element-213">
      {current && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 right-4 sm:left-4 sm:right-auto z-[60] max-w-[340px]" role="status" aria-live="polite" data-id="element-214">
          <div className="bg-white rounded-2xl shadow-2xl border border-navy/10 p-4 flex items-start gap-3" data-id="element-215">
            <div className="flex-shrink-0 mt-0.5" data-id="element-216">
              <CheckCircle2 className="text-emerald" size={28} data-id="element-217" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-218">
              <p className="text-[14px] text-navy leading-snug" data-id="element-219">
                <span className="font-bold" data-id="element-220">{current.purchase.name}</span>
                <span className="text-navy/60" data-id="element-221">
                  {' '}
                  de {current.purchase.location}
                </span>
              </p>
              <p className="text-[13px] text-navy/80 leading-snug" data-id="element-222">
                acaba de comprar{' '}
                <span className="font-semibold" data-id="element-223">{current.product.label}</span>{' '}
                {current.product.emoji}
              </p>
              <p className="text-[11px] text-navy/40 mt-1 flex items-center gap-1" data-id="element-224">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald animate-pulse" data-id="element-225" />
                {current.ago} · Compra verificada
              </p>
            </div>
            <button onClick={() => setCurrent(null)} className="flex-shrink-0 text-navy/30 hover:text-navy/60 transition-colors" aria-label="Cerrar notificación" data-id="element-226">
              <X size={16} data-id="element-227" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}